
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.963 13a.938.938 0 00.69-.307l5.074-5.487a1.05 1.05 0 000-1.413L1.654.308A.93.93 0 00.29.287c-.38.39-.39 1.03-.018 1.432l4.43 4.78-4.43 4.78a1.051 1.051 0 00.018 1.433c.187.193.43.288.672.288z","fill":"#2E50D4"}})])
          )
        }
      }
    